import script from "./find-postcode-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./find-postcode-modal.vue?vue&type=script&setup=true&lang=ts"

import "./find-postcode-modal.vue?vue&type=style&index=0&id=12ad2bf0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ad2bf0"]])

export default __exports__